import React from 'react';
import { Quote } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { Card, CardContent } from './ui/Card';
import { TEMOIGNAGES } from '../data/temoignages';

/**
 * Témoignages écrits des apprenants et entreprises partenaires.
 * La section ne s'affiche que si des témoignages sont renseignés
 * dans data/temoignages.ts — pas de bloc vide sur le site.
 */
export function Temoignages() {
  if (TEMOIGNAGES.length === 0) return null;
  return <section className="py-24 bg-muted" data-id="element-702" data-mp="2kc6chwpgtw69">
      <div className="container max-w-6xl mx-auto" data-id="element-703" data-mp="2kb4q4w301n98">
        <SectionHeading title="Ce qu'ils en disent" subtitle="Les mots de nos apprenants et de nos entreprises partenaires." centered className="mb-16" data-id="element-704" data-mp="26krikuu0sakf" />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-705" data-mp="2ybz2fpt648d6">
          {TEMOIGNAGES.map(t => <Card key={`${t.prenom}-${t.formation}`} className="border-none shadow-lg bg-white overflow-hidden hover:-translate-y-1 transition-transform duration-300" data-id="element-706" data-mp="332feb5hcblxf">
              <div className="h-2 w-full bg-brand-orange" data-id="element-707" data-mp="ul8zkuiy9tus" />
              <CardContent className="p-8 flex flex-col h-full" data-id="element-708" data-mp="uinw613075ux">
                <Quote className="w-8 h-8 text-lavande mb-5 shrink-0" data-id="element-709" data-mp="19aex8e253c0k" />
                <p className="text-muted-foreground leading-relaxed mb-6 flex-1" data-id="element-710" data-mp="14ieru63avqwl">
                  {t.citation}
                </p>
                <div className="pt-5 border-t border-slate-100" data-id="element-711" data-mp="1i909xskxjwtf">
                  <p className="font-extrabold font-heading text-primary-dark leading-tight" data-id="element-712" data-mp="1e99f9dsa8wjm">
                    {t.prenom}
                  </p>
                  <p className="text-sm font-semibold text-brand-orange" data-id="element-713" data-mp="1s7puxu84hxdw">
                    {t.formation}
                  </p>
                  {t.entreprise && <p className="text-sm text-muted-foreground mt-0.5" data-id="element-714" data-mp="3u0x9v2jtqcz9">
                      {t.entreprise}
                    </p>}
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}